import { render, staticRenderFns } from "./AddAccount.vue?vue&type=template&id=22121d8e&scoped=true"
import script from "./AddAccount.vue?vue&type=script&lang=js"
export * from "./AddAccount.vue?vue&type=script&lang=js"
import style0 from "./AddAccount.vue?vue&type=style&index=0&id=22121d8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22121d8e",
  null
  
)

export default component.exports